import React, { forwardRef, useEffect, useState } from "react";
import parse from "html-react-parser";
import IStyledProps from "../../utilities/IStyledProps";
import IEditableProps from "../../utilities/IEditableProps"
import { getApiDataByPath } from './apiDataService';
import useApiData from "./useApiData";

export interface IApiDataProps extends IStyledProps, IEditableProps {
    children: string[];
}

/**
 *  Widget generated by mdx utils by replacing {{ TabbedRates.9.id }} with `<ApiData>TabbedRates.9.id</ApiData>`
 */
const ApiData = forwardRef((props: IApiDataProps, ref: any) => {
    const { children } = props;
    const { data: apiData, status } = useApiData();
    const data = Array.isArray(children) ? children[0] : children;
    const dataParts = data.split(',').map(p => p.trim());
    if (!dataParts || !dataParts.length) {
        // if "{{}}" is found
        return <>[N/A]</>;
    }

    // get dataKey
    const dataKey = dataParts[0];
    // remove dataKey
    dataParts.splice(0, 1);

    // check for formatType
    let formatType;
    if (dataParts.length) {
        const dataTypeIndex = dataParts.findIndex(d => ['$', '%', '#', 'date', 'timeAgo'].includes(d));
        if (dataTypeIndex > -1) { // found a data type
            formatType = dataParts[dataTypeIndex];
            dataParts.splice(dataTypeIndex, 1);
        }
    }

    // check for precision
    let precision;
    if (dataParts.length) {
        precision = Number(dataParts[0]);
    }

    const [displayData, setDisplayData] = useState(() => getApiDataByPath(apiData, dataKey, status, precision ? Number(precision) : null, formatType));

    useEffect(
        () => {
            if (!apiData || !dataKey) return;
            const lookupData = getApiDataByPath(apiData, dataKey, status, precision ? Number(precision) : null, formatType);
            if (lookupData != displayData) {
                setDisplayData(lookupData);
            }
        },
        [apiData, dataKey]
    )

    return parse(displayData.toString());
});

export default ApiData;
(global as any).ApiData = ApiData;
